<parkour-info-card-with-title
  [title]="'ex-jongere-view.info-card.title' | translate"
  class="mb-4 block"
>
  <p>{{ 'ex-jongere-view.info-card.description' | translate }}</p>
</parkour-info-card-with-title>
